module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-12-e2ce716a3d8e38d4ec55bdedd122a6ce.svg";